import React, { useEffect, useState } from 'react';
import 'react-day-picker/lib/style.css';
import SlotPicker from '../SlotPicker/index';
import DatePicker from '../DatePicker/index';
import actionConstants from '../../services/scheduler/constants';
import { useDispatch, useSelector } from 'react-redux'
import HourSlots from '../SlotPicker/HourSlots';
import { InfoMessage } from './../Messages/index';
import HelpIcon from '@material-ui/icons/Help';
const dateFormat = 'MM/DD/YYYY'

const Scheduler = ({
    submitSenderer = () => null,
    customTimeSlots = null,
    hoursMultiselect = false,
    datePickerModifiers,
    readOnly = false,
    attendeeSchedulesList = [],
    eventName,
    specialInstructions,
    isSlotsFull,
    isBooked,
    CheckSlotDetailsFill = (e) => null,
    contactform,
    attendeeId,
    eventId,
    CheckWaitingList,
    isHost = false,
}) => {

    const dispatch = useDispatch();
    const activeDay = useSelector(state => state.scheduler.activeDateSlot);
    const schedule = useSelector(state => state.scheduler.schedule);

    const [isSlotEmpty, setIsSlotEmpty] = useState(false);
    const [selectedDay, setSelectedDay] = useState(null);

    var selectedDays = useSelector(state => Object.keys(state.scheduler.schedule))

    if (selectedDays !== undefined && selectedDays !== null && selectedDays.length > 0) {
        selectedDays = selectedDays.sort(function (a, b) {
            a = new Date(a);
            b = new Date(b);
            if (a > b) return 1;
            if (a < b) return -1;
            return 0;
        });
    }
    const EventName = useSelector(state => state.slotPickupData.eventName)
    const EventDate = useSelector(state => state.slotPickupData.eventDate)

    useEffect(() => {
        if (isHost) {
            checkIsEmpty(activeDay, true);
        }
    }, [activeDay, schedule])
    const checkDateExists = (day) => {
        var isvalid = false;
        if (!isEmpty(schedule)) {
            if (schedule[day] !== undefined) {
                isvalid = true;
            }
        }
        return isvalid;
    }
    const showSlot = (value) => {
        dispatch({ type: actionConstants.SET_ACTIVE_DAY_SLOT, data: value })
    }
    const handleDayClick = (day) => {
        //if (readOnly || customTimeSlots) return;
        if (readOnly === true || customTimeSlots) {
            if (checkDateExists(day)) {
                showSlot(day);
            }
            return;
        }
        //if (customTimeSlots) {
        //    if (checkDateExists(day)) {
        //        showSlot(day);
        //    }
        //    return;
        //}
        if (isHost) {
            let isSelectedSlot = checkEmptySlotOrNot(day, false)
            if (isSelectedSlot) {
                dispatch({ type: actionConstants.TOGGLE_DAY, data: day });
                setIsSlotEmpty(false)
                setSelectedDay(day)
            }
            else {
                setIsSlotEmpty(true)

            }
        }
        else {
            dispatch({ type: actionConstants.TOGGLE_DAY, data: day });
        }
    }

    const isEmpty = (obj) => {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    const checkEmptySlotOrNot = (day, isCheckCurrentDay) => {
        var isvalid = true;
        if (!isEmpty(schedule)) {
            if (!schedule[day] || isCheckCurrentDay === true) {
                for (let key in schedule) {
                    if (schedule[key].length <= 0) {
                        isvalid = false
                    }
                }
            }
        }
        return isvalid;
    }

    const checkIsEmpty = (day, IsCheckInCurrentDay) => {
        var isSelectedSlot = "";
        if (isHost) {
            isSelectedSlot = checkEmptySlotOrNot(day, IsCheckInCurrentDay)
            if (isSelectedSlot) {
                setIsSlotEmpty(false)
            }
            else {
                setIsSlotEmpty(true)
            }
        }
        else {
            isSelectedSlot = true;
        }
        return isSelectedSlot;
    }
    const setActiveDate = (activeDay) => {
        setSelectedDay(activeDay);
    }
    const handleSlotClick = (data) => {
        if (readOnly) return;
        dispatch({ type: actionConstants.TOGGLE_SLOT, data })
        checkIsEmpty(data.activeDay, false);
    }

    //console.log(customTimeSlots[0].duration)
    return (
        <div className={'scheduler' + (readOnly ? " host-view" : "") + ((readOnly || attendeeId) && !customTimeSlots === undefined ? " host-container" : "")}>
            <div className={"scheduler__left event-information-box-left " + (attendeeId !== undefined ? " confirm-attendee-view" : "") + (!readOnly ? " mtop" : "")} >

                {
                    !readOnly && (
                        <>
                            <InfoMessage title='Specify the date of your event.' />
                        </>
                    )
                }


                <div style={readOnly ? { 'display': 'none' } : {}}>


                    <h3 className='page-title page-title__descr'>Event Schedule</h3>
                    <DatePicker
                        selectedDays={selectedDays}
                        onChange={handleDayClick}
                        format={dateFormat}
                        numberOfMonths={2}
                        modifiers={datePickerModifiers}
                        readOnly={readOnly || customTimeSlots}
                    />
                    {isHost && isSlotEmpty &&
                        <div className="empty-slot-required-info">
                        
                        <InfoMessage title={'Please set your event time for ' + selectedDay + '. You can add more dates after setting your time slots. To remove a date, click the selected date on the calendar. Once finished, you can confirm your selection(s) by clicking the box(es) below.'
                            } />
                        </div>
                    }
                    <div>
                        <SlotPicker
                            selectedDays={selectedDays}
                            checkIsEmpty={(day, IsCheckInCurrentDay) => checkIsEmpty(day, IsCheckInCurrentDay)}
                            setActiveDate={(activeDay) => setActiveDate(activeDay)}
                        />
                    </div>
                </div>

                {
                    readOnly && customTimeSlots && (
                        <div className="event-information-box-left-inner">
                            <div>{EventName}</div>
                            <div>{EventDate}</div>
                        </div>
                    )
                }

                {readOnly && <div className='submit-renderer'>
                    <>
                        {submitSenderer()}
                        {contactform}
                    </>
                </div>
                }




            </div>
            <div className={'scheduler__right event-information-box-right' + (customTimeSlots ? " attendee-view" : "") + " " + (attendeeId !== undefined ? "confirm-attendee-view" : "")}>

                {
                    //    !readOnly && (
                    //    <div className='info-tooltip-message help-icon'>Select time slots below and then click on the <HelpIcon className="icon-style" /> icon to set number of attendees and duration.</div>
                    //)
                }

                {//!customTimeSlots && (
                    <HourSlots
                        step={30}
                        dateRange={['06:00', '20:00']}
                        activeDay={activeDay}
                        selectedSlots={schedule[activeDay]}
                        onChange={handleSlotClick}
                        customTimeSlots={customTimeSlots}
                        multiselect={hoursMultiselect}
                        readOnly={readOnly}
                        attendeeSchedulesList={attendeeSchedulesList}
                        eventName={eventName}
                        specialInstructions={specialInstructions}
                        CheckSlotDetailsFill={(e) => CheckSlotDetailsFill(e)}
                        attendeeId={attendeeId}
                        eventId={eventId}
                        CheckWaitingList={(day, time) => CheckWaitingList(day, time)}
                        setActiveDate={(activeDay) => setActiveDate(activeDay)}

                    />
                    //)
                }

                {
                    //    isBooked && (
                    //    <div style={{ marginBottom: '15px' }}>
                    //        <ActionButton onClick={() => toggleCancelModalState(true)} title='Cancel event' />
                    //    </div>
                    //)

                    //customTimeSlots && (
                    //    <>
                    //        <div>
                    //            <div><b>Event Information:</b></div>
                    //            <div>{specialInstructions}</div>
                    //                <div><span><b>Duration:</b> {getDuration()}</span></div>

                    //        </div>
                    //    </>
                    //)
                }

            </div>


            {!readOnly && (<div className='submit-renderer'>{submitSenderer()}</div>)}

        </div>

    );
}

export default Scheduler